import type { SupabaseClient, User } from '@supabase/supabase-js';

export type AuthPortalRole = 'coach' | 'client';

/**
 * Resolves coach vs client for portal checks (metadata first, then profiles.role).
 */
export async function resolveAuthPortalRole(sb: SupabaseClient, user: User): Promise<AuthPortalRole | null> {
  let role = (user.user_metadata as { role?: string })?.role;
  if (role !== 'coach' && role !== 'client') {
    role = (user.app_metadata as { role?: string })?.role;
  }
  if (role !== 'coach' && role !== 'client') {
    const { data: prof } = await sb.from('profiles').select('role').eq('id', user.id).maybeSingle();
    if (prof?.role === 'coach' || prof?.role === 'client') {
      role = prof.role;
    }
  }
  return role === 'coach' || role === 'client' ? role : null;
}
